export const geofence = {
  cancel: "Cancel",
  OK: "OK",
  save: "Save",
  geofencNameCannotBeEmpty: "Please input a Geofence name",
  descriptionCannotBeEmpty: "Please input the description",
  geofenceCannotBeEmpty: "Please draw the Geofence on map.",
  savedSuccessfully: "Saved successfully.",
  duplicateGeofenceName: "Geofence name already exists.",
  failedToAddGeofence: "Failed to save.",
  geofenceDoesNotExists: 'Geofence "{name}" does not exist.',
  failedToEditGeofence: "@:geofence.failedToAddGeofence",
  confirmDeletion: "Confirm Deletion",
  // Format: type ["detail1", "detail2", ......]
  confirmDeletionContent:
    'The Geofence "{name}" will be deleted. Are you sure you want to proceed? | The Geofence "{name}" will be deleted. This electronic fence is associated with vehicles. Are you sure you want to proceed?',
  deletedSuccessfully: "Deleted successfully.",
  failedToDeleteGeofence: "Failed to delete.",
  boundariesShouldNotIntersectWithEachOther:
    "Boundaries should not intersect with each other.",
  newGeofence: "New Geofence",
  editGeofence: "Edit Geofence",
  geofenceName: "Geofence Name",
  description: "Description",
  locate: "Locate",
  next: "Next",
  bindVehiclesToThisGeofence: "Apply Geofence to Vehicles and Set Alert Rules",
  boundVehicles: "Vehicles",
  search: "Search",
  pleaseInputVehicleID: "Vehicle ID",
  allFleets: "All Fleets",
  vehicle: "Vehicle",
  enterZone: "Enter Zone",
  exitZone: "Exit Zone",
  circle: "Circle",
  polygon: "Polygon",
  clear: "Clear",
};
